export default function FormField({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
}) {
  const fieldId = name ? `field-${name}` : undefined;

  return (
    <div className={type === 'textarea' ? 'form-group form-group--textarea' : 'form-group'}>
      <label htmlFor={fieldId}>
        {label}
        {required ? ' *' : ''}
      </label>
      {type === 'textarea' ? (
        <textarea
          id={fieldId}
          name={name}
          value={value}
          required={required}
          onChange={(event) => onChange(event.target.value)}
          rows={4}
        />
      ) : (
        <input
          id={fieldId}
          name={name}
          type={type}
          value={value}
          required={required}
          onChange={(event) => onChange(event.target.value)}
        />
      )}
    </div>
  );
}
